import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
const initState = {
    status: '0',
    form: null,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 搜索列表 */
        onChange(payload, { update, state, rootState }) {
            console.log('payload', payload);
            if (payload.time) {
                payload.startDate = payload.time[0];
                payload.endDate = payload.time[1];
                delete payload.time;
            }
            dispatch.cashMargin.SET_STATE({
                searchData: payload,
            });
            const param = Object.assign({}, payload);
            const { status } = rootState.cashTop;
            param.status = status;
            dispatch.cashMargin.load(Object.assign(Object.assign({}, param), { page: 1 }));
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_STATUS(state, payload) {
            state.status = payload;
        },
        CLEAR_SEARCH(state, payload) {
            state.form.resetFields();
        },
    },
});
